import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
//import { debug } from 'node:console';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-fertilizer-remainder',
  templateUrl: './fertilizer-remainder.component.html',
  styleUrls: ['./fertilizer-remainder.component.scss'],
  providers: [DatePipe],
})
export class FertilizerRemainderComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  statelist;
  statedata;
  disable = false;
  response;
  states: string[];
  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  regexStr = '^[0-9]*$';

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      notification: [
        '',
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
      attachlink: ['', [Validators.pattern(this.reg)]],
      fcstates: [''],
      Remark: [''],
    });

    this.spinner.show();

    this._userService.getStates().subscribe((data) => {
      this.statedata = data;
      this.states = this.statedata.result.data;
      this.spinner.hide();
    });
  }
  get attach_url() {
    return this.form.get('attachlink');
  }
  // get attach_notification() { return this.form.get('notification') };
  onSubmit() {
    // debugger

    this.submitted = true;
    if (this.form.valid) {
      if (this.form.value.notification != '') {
        var check = new RegExp(this.regexStr);
        var checkresult = check.test(this.form.value.notification);
        if (checkresult == true) {
          confirm('Do u want to proceed with numeric data?');
          return false;
        }
      }
      if (this.form.value.attachlink != '') {
        var pattern = new RegExp(this.reg);
        var result = pattern.test(this.form.value.attachlink);
        if (result == false) {
          alert('Please enter valid attach link');
          return false;
        }
      }

      this.spinner.show();
      var formdata = {
        Notification: this.form.value.notification,
        States: this.form.value.fcstates,
        Attachlink: this.form.value.attachlink,
      };
      if (
        confirm(
          'Do you want to send this notification to selected state/s users?'
        )
      ) {
        this._userService
          .postapplicationremainder(formdata)
          .subscribe((data) => {
            this.response = data;
            // if (confirm("Do you want to send this notification to selected state/s users?")) {

            this._userService
              .sentapplicationremaindernotification(formdata)
              .subscribe((data) => {
                this.response = data;
              });
            this.spinner.hide();
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
          });
      }
      this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/Fertilizer']);
        this.spinner.hide();
      });
    } else {
      alert('Please fill all mandatory fields and enter valid values');
    }
  }
  listPage() {
    this.router.navigate(['/FertilizerList']);
  }
}
